import { render, staticRenderFns } from "./AddressBlock.vue?vue&type=template&id=c00436fa&scoped=true"
import script from "./AddressBlock.vue?vue&type=script&lang=js"
export * from "./AddressBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00436fa",
  null
  
)

export default component.exports